import {
    GET_SYNC_STATUS_REQUEST,
    GET_SYNC_STATUS_SUCCESS,
    GET_SYNC_STATUS_FAILURE,
    START_SYNC_REQUEST,
    START_SYNC_SUCCESS,
    START_SYNC_FAILURE
} from './constants';
import {IActions} from './typedef';

interface State {
    status: boolean;
    pending: boolean;
}

const initialState: State = {
    status: false,
    pending: false
};

const sync = (state = initialState, action: IActions) => {
    switch (action.type) {
        case GET_SYNC_STATUS_REQUEST:
            return {
                ...state,
                pending: true
            };
        case GET_SYNC_STATUS_SUCCESS:
            return {
                ...state,
                status: action.status,
                pending: false
            };
        case GET_SYNC_STATUS_FAILURE:
            return {
                ...state,
                pending: false
            };

        case START_SYNC_REQUEST:
            return {
                ...state
            };
        case START_SYNC_SUCCESS:
            return {
                ...state,
                status: action.status
            };
        case START_SYNC_FAILURE:
            return {
                ...state
            };
        default:
            return state;
    }
};

export {sync};
